export class PafAudit {
  id: number;
  pafNumber: number;
  initialAuditDate: Date;
  postAuditDate: Date;
  status: string;
  auditor: string;
  dataTech: string;
  comments: string;
  rejectionComments: string;
  enteredBy: string;
  enteredAt: Date;
  updatedBy: string;
  updatedAt: Date;
  attachments: string;
}
